jQuery(document).ready(function(){
    jQuery('.wp-block-vif-card-slider').each(function(){
        let currentSlider = jQuery(this);
        new cardSlider(currentSlider);
    })
})

class cardSlider {
    constructor(dom){
        this.dom = dom;
        this.sliderClock = null;
        this.activeSlide = 1;
        this.duration = this.dom.data('duration') ? parseInt(this.dom.data('duration'))*10 : 3000;
        this.startSlider(this);
    }
    startSlider(instance){
        instance.dom.addClass('slider-active');
        instance.sliderClock = setInterval(function(){instance.nextSlide(instance)}, instance.duration);
        instance.setActiveSlider(instance);
    }
    resetClock(instance){
        clearInterval(instance.sliderClock);
        instance.sliderClock=null;
        instance.sliderClock = setInterval(function(){instance.nextSlide(instance)}, instance.duration);
    }
    stopSlider(instance){
        clearInterval(instance.sliderClock);
        instance.sliderClock=null;
        instance.dom.removeClass('slider-active');
    }
    nextSlide(instance){
        let numberOfSlide = instance.dom.find('img').length;
        instance.activeSlide = instance.activeSlide>=numberOfSlide ? 1 : instance.activeSlide+1;
        instance.setActiveSlider(instance);
    }
    prevSlide(instance){
        instance.activeSlide = instance.activeSlide<=1 ? instance.dom.find('img').length : instance.activeSlide-1;
        instance.setActiveSlider(instance);
    }
    setActiveSlider(instance){
        instance.dom.addClass('transition');
        let oldActiveSlider = instance.dom.find('img.active');
        let activeSlide = instance.dom.find('img:nth-child('+(instance.activeSlide)+')');
        oldActiveSlider.removeClass('active');
        activeSlide.addClass('active');
        setTimeout(function(){
            instance.dom.removeClass('transition')
        }, 300)
    }

}